<template>
    <auth-layout width="md">
        <template #headerRight>
            <div class="text-sm">
                Celà vous prendra que quelques minutes /
                <a class="font-medium text-indigo-500 hover:text-indigo-600"
                   href="#" @click.prevent="logout">
                    Se déconnecter
                </a>
            </div>
        </template>
        <template #headerBottom>
            <div class="px-4 pt-12 pb-8">
                <div class="max-w-md mx-auto w-full">
                    <div class="relative">
                        <div class="absolute left-0 top-1/2 -mt-px w-full h-0.5 bg-gray-200" aria-hidden="true"></div>
                        <ul class="relative flex justify-between w-full">
                            <li v-for="s in steps" :key="s">
                                <a :class="'flex items-center justify-center w-6 h-6 rounded-full text-xs ' +
                                 'font-semibold ' + (step >= s ? 'bg-indigo-500' : 'bg-gray-100') + ' text-white'" href="#">
                                    {{ s }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
        <div class="max-w-md mx-auto">
            <div v-if="step === 1">
                <h1 class="text-3xl text-gray-800 font-bold mb-6">
                    Parlez-nous de votre société ✨
                </h1>
                <div class="space-y-3 mb-8">
                    <jet-input-error :message="form.errors.type" />
                    <label v-for="(type, index) in types" :key="index" class="relative block cursor-pointer">
                        <input type="radio" :value="type.id"
                               name="form_type"
                               required
                               :selected="index === 0"
                               v-model="typeModel"
                               class="peer sr-only"/>
                        <div class="flex items-center bg-white text-sm font-medium text-gray-800 p-4
                            rounded border border-gray-200 hover:border-gray-300 shadow-sm duration-150 ease-in-out">
                            <svg class="w-6 h-6 shrink-0 fill-current mr-4" viewBox="0 0 24 24">
                                <path class="text-indigo-500"
                                      d="m12 10.856 9-5-8.514-4.73a1 1 0 0 0-.972 0L3 5.856l9 5Z"/>
                                <path class="text-indigo-300"
                                      d="m11 12.588-9-5V18a1 1 0 0 0 .514.874L11 23.588v-11Z"/>
                                <path class="text-indigo-200"
                                      d="M13 12.588v11l8.486-4.714A1 1 0 0 0 22 18V7.589l-9 4.999Z"/>
                            </svg>
                            <span>Vous êtes {{ type.description }}</span>
                        </div>
                        <div class="absolute inset-0 border-2 border-transparent peer-checked:border-indigo-400
                            rounded pointer-events-none" aria-hidden="true"></div>
                    </label>
                </div>
                <div class="flex items-center justify-between space-x-6 mb-8">
                    <div>
                        <div class="font-medium text-gray-800 text-sm mb-1">💸
                            Pourquoi dois je choisir le type de ma société ?
                        </div>
                        <div class="text-xs">
                            Nous avons une base de donnée d'article prêt à
                            l'emploi en fonction de votre type de société.
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="step === 2">
                <h1 class="text-3xl text-gray-800 font-bold mb-6">
                    Informations de votre société ✨
                </h1>
                <div class="space-y-3 mb-8">
                    <!--div>
                        <label class="block text-sm font-medium mb-1" for="company-name">
                            Nom de la société
                        </label>
                        <input id="company-name" v-model="form.name" required class="form-input w-full" type="text" />
                        <jet-input-error :message="form.errors.name" />
                    </div-->
                    <div>
                        <label class="block text-sm font-medium mb-1" for="email">
                            Adresse email
                        </label>
                        <input id="email" required v-model="form.email" class="form-input w-full" type="text" />
                        <jet-input-error :message="form.errors.email" />
                    </div>
                    <div>
                        <label class="block text-sm font-medium mb-1" for="phone">
                            Numéro de téléphone
                        </label>
                        <vue-tel-input required @input="phoneInput" />
                        <jet-input-error :message="form.errors.phone" />
                    </div>
                    <div>
                        <label class="block text-sm font-medium mb-1" for="address">
                            Localisation
                        </label>
                        <input id="address" required v-model="form.address" class="form-input w-full" type="text" />
                        <jet-input-error :message="form.errors.address" />
                    </div>
                </div>
            </div>

            <div v-if="step === 3">
                <h1 class="text-3xl text-gray-800 font-bold mb-6">
                    Vos taux de service
                </h1>
                <div class="flex items-center justify-between space-x-6 mb-8">
                    <div>
                        <div class="text-xs">
                            Étant un outil d'aide à la prise de décision,
                            les taux de service sont très important pour une meilleure
                            prise de décision sur les différents articles.
                        </div>
                    </div>
                </div>
                <div class="space-y-3 mb-8">
                    <div class="text-sm bg-yellow-300 text-gray-800 p-3 rounded-lg rounded-tl-none border border-gray-200 shadow-md mb-1">
                        Taux de service selon leur volumes de vente
                    </div>
                    <jet-input-error :message="form.errors.rate_volume" />
                    <div class="flex space-x-4">
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_a"
                                       v-model="form.rate_volume.a"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">A</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_b"
                                       v-model="form.rate_volume.b"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">B</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_c"
                                       v-model="form.rate_volume.c"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">C</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 50px !important"
                         class="text-sm bg-green-300 text-gray-800 p-3 rounded-lg rounded-tl-none border border-gray-200 shadow-md mb-1">
                        Taux de service selon leur stabilité
                    </div>
                    <jet-input-error :message="form.errors.rate_stability" />
                    <div class="flex space-x-4">
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_x"
                                       v-model="form.rate_stability.x"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">X</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_y"
                                       v-model="form.rate_stability.y"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">Y</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1">
                            <div class="relative">
                                <input id="rate_z"
                                       v-model="form.rate_stability.z"
                                       class="form-input w-full pl-12" type="text">
                                <div class="absolute inset-0 right-auto flex items-center pointer-events-none">
                                    <span class="text-sm text-gray-400 font-medium px-3">Z</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-between">
                <a v-if="step > 1 && step !== steps"
                   @click.prevent="step--"
                   class="text-sm underline hover:no-underline" href="#">
                    &lt;- Retour
                </a>
                <a v-if="step !== steps" class="btn bg-indigo-500 hover:bg-indigo-600 text-white ml-auto"
                   @click.prevent="nextStep"
                   href="#">
                    Prochaine étape -&gt;
                </a>
                <a href="#" @click.prevent="store" v-if="step === steps"
                        class="btn bg-indigo-500 hover:bg-indigo-600 text-white ml-auto">
                    Terminer -&gt;
                </a>
            </div>
        </div>
    </auth-layout>
</template>

<script>
    import {defineComponent} from 'vue'
    import AuthLayout from '@/Layouts/AuthLayout.vue'
    import JetInputError from '@/Jetstream/InputError'

    export default defineComponent({
        components: {
            AuthLayout,
            JetInputError,
        },

        props: {
            types: {
                type: Array
            }
        },

        data() {
            return {
                step: 1,
                steps: 3,
                typeModel: '',
                form: this.$inertia.form({
                    type: '',
                    email: '',
                    phone: '',
                    dial_code: '',
                    iso2: '',
                    address: '',
                    rate_volume: {
                        a: 0,
                        b: 0,
                        c: 0,
                    },
                    rate_stability: {
                        x: 0,
                        y: 0,
                        z: 0,
                    },
                })
            }
        },

        methods: {
            phoneInput(number, phoneObject) {
                if(number !== undefined && phoneObject !== undefined) {
                    this.form.phone =  number ? number : ''
                    this.form.dial_code = phoneObject ? phoneObject.country.dialCode : null
                    this.form.iso2 = phoneObject ? phoneObject.country.iso2 : null
                }
            },

            nextStep() {
                this.step ++
            },

            logout() {
                this.$inertia.post(route('logout'));
            },

            store() {
                this.form
                    .transform((data) => ({
                        ...data,
                        type: this.typeModel,
                    }))
                    .post(route('saas.configuration.store'));
            }
        }
    })
</script>

<style scoped>

</style>
